import { request } from "@/utils/remoteRequest";

// 模板列表
export function getTemplate(data) {
  return request({
    url: "/template/searchTemplatesByQc",
    method: "post",
    data,
  });
}

// 基础数据
export function getBasicData(data) {
  return request({
    url: "/basicData/searchBasicData",
    method: "post",
    data,
  });
}


export function getBirthLocalData(data) {
  return request({
    url: "/basicData/searchBasicDataByParentId",
    method: "post",
    data,
  });
}

export function searchBasicDataById(data) {
  return request({
    url: "/basicData/searchBasicDataById",
    method: "post",
    data,
  });
}

// 批量基础数据
export function getBasicDataBatch(data) {
  return request({
    url: "/basicData/searchBasicDataByTypeCodeList",
    method: "post",
    data,
  });
}

// 根据职位id查询职位信息
export function searchPostInfoById(data) {
  return request({
    url: "/postInfo/searchPostInfoById",
    method: "post",
    data,
  });
}

// 职位发布
export function savePostInfo(data) {
  return request({
    url: "/postInfo/publishPostInfo",
    method: "post",
    data,
  });
}

// 保存模板
export function saveTemplate(data) {
  return request({
    url: "/template/save",
    method: "post",
    data,
  });
}
